/**
 * App stages enumeration
 * @enum {string}
 * @export
 */
export enum APP_STAGE {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	STAGING = 'staging',
	BETA = 'beta',
}

/**
 * App local environment
 * @enum {string}
 * @export
 */
export enum APP_ENV {
	DEVELOPMENT = 'development',
	PRODUCTION = 'production',
	TEST = 'test',
}

/** runtime stage environment checks */
export const IS_PRODUCTION = process.env.NEXT_PUBLIC_APP_STAGE === APP_STAGE.PRODUCTION;
export const IS_DEVELOPMENT = process.env.NEXT_PUBLIC_APP_STAGE === APP_STAGE.DEVELOPMENT || process.env.NEXT_PUBLIC_APP_STAGE === undefined;
export const IS_STAGING = process.env.NEXT_PUBLIC_APP_STAGE === APP_STAGE.STAGING;
export const IS_BETA = process.env.NEXT_PUBLIC_APP_STAGE === APP_STAGE.BETA;
export const IS_LOCAL = process.env.NODE_ENV === APP_ENV.DEVELOPMENT;
export const IS_DEPLOYED = process.env.NODE_ENV === APP_ENV.PRODUCTION;

/**
 * App supported locales
 * @enum {string}
 * @export
 */
export enum APP_LOCALE {
	CS = 'cs',
	EN = 'en',
	DE = 'de',
	SK = 'sk',
}

/**
 * App supported i18n namespaces
 * @enum {string}
 * @export
 */
export enum APP_I18N_NAMESPACE {
	MAIN = 'main',
	COMMON = 'common',
}

/**
 * Supported authentication providers enumeration
 * @export
 */
export enum AUTH_PROVIDER {
	CREDENTIALS = 'credentials',
	TOKEN = 'token',
	PASSWORDLESS = 'passwordless',
}
